import { useEffect, useState } from "react";

import { MdArrowForwardIos } from "react-icons/md";
import { MdArrowBackIos } from "react-icons/md";

import useDate from "../../hooks/useDate";

import "./style.css";
import { delay, padNumber, swapArrayElements } from "../../utils";

function CustomCalendar({
    id = "",
    className = "",
    highlights = {
        type: "week", // week, day
        values: {
            // week: { // 0: Sunday, 1: Monday, 2: Tuesday, 3: Wednesday, 4: Thursday, 5: Friday, 6: Saturday
            // 0: {
            //     backgroundColor: "red"
            // }
            // }

            // day: { 1-31
            // 1: {
            //     backgroundColor: "red"
            // }
            // }
        }
    },
    tags = {
        // 1: "solid-orange-circle",
        // 5: "circle-question
    },
    showHeader = true,
    full = true,
    onChange = () => { },
    onboarding = false,
    pointDate,
    calendarDates,
}) {
    const now = new Date();
    const { GetCalendarMatrix, GetMonthDates, GetCurrentDay, GetWeekOfMonth, GetToday } = useDate();
    const [currentDate, setCurrentDate] = useState(new Date());
    const [shape, setShape] = useState("cc-square");
    const [selectedCell, setSelectedCell] = useState(null);
    const [matrix, setMatrix] = useState([]);
    const [originalMatrix, setOriginalMatrix] = useState(null);
    const monthMatrix = GetCalendarMatrix({
        date: currentDate,
        full: full,
        pointDate: pointDate,
    });
    const { startDate, endDate, year, month, day } = GetMonthDates(currentDate);
    const hasScheduled = Object.keys(highlights?.values).length > 0;
    const weekOfMonth = GetWeekOfMonth(currentDate);
    const currentDay = GetCurrentDay();
    const today = GetToday();

    const HandleBack = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
    }

    const HandleForward = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
    }

    const HandleDateSelection = (cell) => {
        setSelectedCell({ ...cell });
        onChange({ ...cell });
    }

    const tagElements = {
        "solid-orange-circle": <div className="cc-tag solid-orange-circle"></div>,
        "circle-question": <div className="cc-tag circle-question flex-c">?</div>,
    }

    // useEffect(() => {
    // }, [monthMatrix]);

    useEffect(() => {
        if (showHeader) {
            setShape("cc-rounded");
            setMatrix([...originalMatrix])
        } else {
            if (hasScheduled && !onboarding && (month == now.getMonth() + 1 && year == now.getFullYear())) {
                setMatrix(swapArrayElements(matrix, 0, selectedCell?.weekPosition ? (selectedCell?.weekPosition - 1) : (weekOfMonth - 1)));
            }
            delay(() => {
                setShape("cc-square");
            }, 300)
        }
    }, [showHeader, hasScheduled]);

    useEffect(() => {

        if (!showHeader && hasScheduled && !onboarding && (month == now.getMonth() + 1 && year == now.getFullYear() && (selectedCell?.month == month && selectedCell?.year == year))) {
            setMatrix(swapArrayElements(monthMatrix, 0, selectedCell?.weekPosition ? (selectedCell?.weekPosition - 1) : (weekOfMonth - 1)));
        } else {
            setMatrix(monthMatrix);
            !originalMatrix && setOriginalMatrix([...monthMatrix]);
        }

        setSelectedCell({
            day: day,
            month: month,
            year: year
        });
    }, [startDate, pointDate]);

    let weekNo = null;

    const wpStartDate = new Date(`${calendarDates?.startDate?.year}-${calendarDates?.startDate?.month}-${calendarDates?.startDate?.day}`);
    const wpEndDate = new Date(`${calendarDates?.endDate?.year}-${calendarDates?.endDate?.month}-${calendarDates?.endDate?.day}`);
    const wpRenewDate = `${calendarDates?.dateAfterEndDate?.year}-${calendarDates?.dateAfterEndDate?.month * 1}-${calendarDates?.dateAfterEndDate?.day * 1}`

    return (
        <div
            id={id}
            className={`custom-calendar ${className} ${shape}`}
            style={{ height: (showHeader || onboarding) ? (monthMatrix?.length > 5 ? "470px" : "420px") : (onboarding ? "" : "105px") }}
        >
            {(showHeader || onboarding) ? <div className="cc-header flex-c">
                <MdArrowBackIos onClick={HandleBack} />
                <span>{`${startDate} - ${endDate}`}</span>
                <MdArrowForwardIos onClick={HandleForward} />
            </div> : null}
            <table>
                <thead>
                    <tr>
                        <th>SU</th>
                        <th>M</th>
                        <th>T</th>
                        <th>W</th>
                        <th>TH</th>
                        <th>F</th>
                        <th>S</th>
                    </tr>
                </thead>
                <tbody>
                    {matrix.map((week, i) => {
                        return (
                            <tr key={i}>
                                {week.map((cell, j) => {
                                    let styles = null;
                                    let key = `${year}-${cell?.month}-${cell?.day}`;
                                    let key2 = `${year}-${padNumber(cell?.month)}-${padNumber(cell?.day)}`;
                                    let dayDate = new Date(`${year}-${padNumber(cell?.month, 2)}-${padNumber(cell?.day, 2)}`);

                                    styles = highlights?.type === "week" ? highlights?.values[key] : ({ ...highlights?.values?.[cell?.dayOrder]?.[cell?.day] } || null);
                                    delete styles?.program;

                                    const withinRange = dayDate >= wpStartDate && dayDate <= wpEndDate;

                                    console.log("------------------------");
                                    console.log("key", key);
                                    console.log("today?.key", today?.key);
                                    return (
                                        <td key={key}>
                                            <div className="cc-day-wapper flex-c">
                                                <div
                                                    style={(cell?.day && withinRange) ? { ...styles } : {}}
                                                    className={
                                                        `flex-c cc-day ${((!cell?.day) || (cell?.month != month)) ? "cc-day-disable" : ""} ${`${selectedCell?.year}-${selectedCell?.month}-${selectedCell?.day}` == key ? "cc-day-selected" : ""} ${key2 == today?.key ? "cc-day-today" : ""} ${(cell?.day && withinRange) ? "cc-scheduled" : ""}`
                                                    }
                                                    onClick={() => HandleDateSelection(cell)}>
                                                    {cell?.day}
                                                    {(key == wpRenewDate) ? tagElements["circle-question"] : ""}
                                                    {/* {(key == today?.key) ? tagElements["solid-orange-circle"] : ""} */}
                                                </div>

                                            </div>
                                        </td>
                                    );
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default CustomCalendar;